// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ResetPasswordInternalRequestModel {
    'emails': Array<string>;
    'portalUserDatabase'?: string;
    'portalClientId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ResetPasswordInternalRequestModel>> = [
        {
            "name":     "emails",
            "baseName": "emails",
            "type":     "Array<string>"
        },
        {
            "name":     "portalUserDatabase",
            "baseName": "portalUserDatabase",
            "type":     "string"
        },
        {
            "name":     "portalClientId",
            "baseName": "portalClientId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ResetPasswordInternalRequestModel.attributeTypeMap;
    }
}
